import { IUser } from 'app/shared/model/user.model';
import { IMailType } from 'app/shared/model/mail-type.model';

export interface IOrder {
  id?: number;
  code?: string;
  quantity?: number;
  totalPrice?: number;
  isApproved?: boolean | null;
  result?: string | null;
  createdDate?: string | null;
  user?: IUser | null;
  mailType?: IMailType | null;
}

export interface ICreateOrder {
  mailTypeId: number;
  quantity: number;
}

export const defaultValue: Readonly<IOrder> = {
  isApproved: false,
};
